import {Subject} from "rxjs";

type PageTitle = {
    name: string;
}

export class PageTitleService {

    private _currentTitle: PageTitle = null;

    pageTitleSubject: Subject<PageTitle> = new Subject();

    public static instance = [PageTitleService];

    subscribe = (subscriber: (pageTitle: PageTitle) => void) => {
        this.pageTitleSubject.subscribe(subscriber);
    };

    get currentTitle(): PageTitle {
        return this._currentTitle;
    }

    set currentTitle(value: PageTitle) {
        if (!this._currentTitle) {
            this._currentTitle = value;
        }
        this._currentTitle.name = value.name;
        this.pageTitleSubject.next(value);
    }
}